enum QBOGlobalTaxCalculationEnum {
    TAX_EXCLUDED = "TaxExcluded",
    TAX_INCLUSIVE = "TaxInclusive",
    NOT_APPLICABLE = "NotApplicable",
}

export default QBOGlobalTaxCalculationEnum;
